import { BaseService } from "mrb/core";
import { LoadioArtistApiRouteService } from "common/services";

class LoadioArtistService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioArtistApiRouteService());
    }

    updateActiveStatus(id, value, abortSignal = null) {
        const url = this.routeService.updateActiveStatus(id, value);
        return this.apiClient.put(url, null, null, abortSignal);
    }
}

export default LoadioArtistService;
